import React from 'react';
import PropTypes from 'prop-types';
import styles from '../HistoricalDashboardPage/HistoricalDashboardPage.module.scss';
import { HistoricDataGrid } from '../../components/HistoricDataGrid';
import { IDQS_NIGHT_TRADE_SYMBOL_SUMMARY, IDQS_NIGHT_TRADE_MMID_SUMMARY, IDQS_NIGHT_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_ORDER_MMID_SUMMARY,
  IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY, IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY, IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY, IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY
} from '../../util/dashBoardPageConstants';
import getConfig from '../../config';
const { DASHBOARD_CONFIG } = getConfig();
const IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_TRADE_SYMBOL_SUMMARY);
const IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_TRADE_MMID_SUMMARY);

const IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_ORDER_SYMBOL_SUMMARY);
const IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_ORDER_MMID_SUMMARY);
const IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY);
const IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY);

const IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_UNENTITLED_SYMBOLS_SUMMARY);
const IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG = DASHBOARD_CONFIG.get(IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY);

class HistoricalDashboardIdqsOvernightGrids extends React.PureComponent {
  render () {
    const historicDateFormat = this.props.historicDateFormat;
    return (
      <div className={styles.idqsTables} >

        <HistoricDataGrid
          key={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_TRADE_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20} />

        <HistoricDataGrid
          key={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.totalField}
          columns={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_TRADE_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20} />

        <HistoricDataGrid
          key={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          ket={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.totalField}
          columns={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_OPEN_ORDER_SYMBOL_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.totalField}
          columns={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_OPEN_ORDER_MMID_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

        <HistoricDataGrid
          key={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          identifier={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.identifier}
          header={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.header}
          api={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.lastUpdatedField}
          columns={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_ORDER_TRADE_RATIO_SUMMARY_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />
        <HistoricDataGrid
          key={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.identifier}
          identifier={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.identifier}
          header={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.header}
          api={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.historicApi}
          downloadApi={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.downloadApi}
          historicDate={historicDateFormat}
          lastUpdatedField={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.lastUpdatedField}
          totalField={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.totalField}
          columns={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.columns}
          summaryGroupTitleColumn={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.summaryGroupTitleColumn}
          summaryGroupDataColumn={IDQS_NIGHT_UNENTITLED_SYMBOLS_CONFIG.summaryGroupDataColumn}
          maxRows={20}
        />

      </div>
    );
  }
}

export default HistoricalDashboardIdqsOvernightGrids;
export const MemoizedHistoricalDashboardIdqsOvernightGrids = React.memo(HistoricalDashboardIdqsOvernightGrids);

HistoricalDashboardIdqsOvernightGrids.propTypes = {
  historicDateFormat: PropTypes.string
};
